<template>
	<LicenseGate :license="license">
		<router-view />
	</LicenseGate>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import LicenseGate from "@/components/LicenseGate.vue";

// Route layout that gates an entire subtree behind a license. Set the
// required product on the parent route's meta, e.g.:
//
//   {
//     path: "/_/communication",
//     component: LicenseGateRoute,
//     meta: { license: "reveal" },
//     children: [ ... ],
//   }
//
// Every child route inherits the gate from this single parent.
const route = useRoute();
const license = computed(() => route.meta.license as string | undefined);
</script>
